import camelcaseKeys from "camelcase-keys";
import React, { useState } from "react";
import styled from "styled-components";
import axios from "../../modules/axiosInstance";

import { API_HOST } from "../../config";
import { LoadingContainer } from "../../containers/LoadingContainer";
import { TalkListContainer } from "../../containers/TalkListContainer";
import useNavigationBar from "../../customHook/NavigationBarHook";
import useInterbal from "../../customHook/UseInterbal";
import { navigationBarHeight } from "../../design";
import { IStringTMap, ITalk } from "../../interfaces";
import FilterOptions from "../molecules/FilterOptions";
import ProfileEditModal from "../organisms/AdminProfileEditModal";
import AdminRegisterModal from "../organisms/AdminRegisterModal";
import WithLoading from "../organisms/LoadingHOC";
import PageNavigation from "../organisms/PageNavigation";
import TalkList from "../organisms/TalkList";

interface IProps {}
export type FilterOption = "unfinished" | "default";

export interface IFilterState {
  key: FilterOption;
  checked: boolean;
}

const TalkListPage: React.FC<IProps> = () => {
  const loading = LoadingContainer.useContainer();

  const {
    searchBox,
    adminRegisterModal,
    profileEditModal
  } = useNavigationBar();

  const { talkList, updateTalks } = TalkListContainer.useContainer();

  // filter 項目が増えたらその都度拡張してください。
  const [filterOptions, setFilterOptions] = useState<IFilterState[]>([
    { key: "unfinished", checked: false }
  ]);

  const filterMethods: IStringTMap<(talks: ITalk[]) => ITalk[]> = {
    searchMatched: (talks: ITalk[]) => {
      return talks.filter((t: ITalk) => t.user.displayName.match(""));
    },
    unfinished: talks => {
      return talks.filter(
        (t: ITalk) => t.user.correspondenceStatus === "unfinished"
      );
    }
  };

  const filterTalksByOptions = (talks: ITalk[]) => {
    let filteredTalks: ITalk[] = talks;
    for (const option of filterOptions) {
      if (option.checked) {
        filteredTalks = filterMethods[option.key](talks);
      }
    }
    return filteredTalks;
  };

  const displayTalks: ITalk[] = filterTalksByOptions(
    talkList.talks.filter((t: ITalk) =>
      t.user.displayName.match(searchBox.searchText)
    )
  );

  const TalkListWithLoading = WithLoading(TalkList);

  const fetchTalksWithSinceID = (sinceID: number) => {
    const url = `${API_HOST}/api/talks`;
    axios
      .get(url, {
        params: {
          since_id: sinceID
        }
      })
      .then(results => {
        const data = results.data;
        const talks = data.map((d: object[]) => {
          return camelcaseKeys(d, { deep: true });
        });
        updateTalks(talks);
      })
      .catch(e => {
        console.error(e);
      });
  };

  // コンポーネントの描画後は 5秒ごとにリクエストを送る。
  useInterbal(() => {
    if (talkList.stage === "didMount") {
      fetchTalksWithSinceID(talkList.sinceID);
    }
  }, 5000);

  return (
    <>
      <PageNavigation
        active="talks"
        title="トーク"
        adminRegisterModalState={adminRegisterModal}
        profileEditModalState={profileEditModal}
        searchBoxState={searchBox}
      >
        <AdminRegisterModal
          modalState={adminRegisterModal}
          style={adminRegisterModal.isOpen ? undefined : { display: "none" }}
        />
        <ProfileEditModal
          modalState={profileEditModal}
          style={profileEditModal.isOpen ? undefined : { display: "none" }}
        />
        <TalkListAlign className="talk-list">
          <FilterOptions
            options={filterOptions}
            setFilterOptions={setFilterOptions}
          />
          <TalkListWithLoading
            isLoading={loading.isloading}
            talks={displayTalks}
          />
        </TalkListAlign>
      </PageNavigation>
    </>
  );
};

export default TalkListPage;

const TalkListAlign = styled.div`
  margin-top: ${navigationBarHeight};
`;
